module.exports = __webpack_public_path__ + "img/chat-icon.67142ea1.svg";